/** Redux Reducers. */
import { setFormData as setOimFormData } from '../shared/store/slices/oim-newShipmentSlice';
import { setFormData as setOexFormData } from '../shared/store/slices/oex-newShipmentSlice';
import { setFormData as setAimFormData } from '../shared/store/slices/aim-newShipmentSlice';
import { setFormData as setAexFormData } from '../shared/store/slices/aex-newShipmentSlice';
import { setFormData as setTruckingFormData } from '../shared/store/slices/trucking-newShipmentSlice';

/** Internal Components. */
import {
    oimDialogConfig,
    oexDialogConfig,
    aimDialogConfig,
    aexDialogConfig,
    truckingDialogConfig,
} from './newShipmentConfig';

/** Shipment New Shipment Dialog Configs. */
export const shipmentDialogConfigs = {
    0: oimDialogConfig,
    1: oexDialogConfig,
    2: aimDialogConfig,
    3: aexDialogConfig,
    4: truckingDialogConfig,
};

/** Shipment Delete Actions. */
export const shipmentDeleteActions = {
    0: { tableName: 'il_ocean_import', reducerName: 'setOimDelete' },
    1: { tableName: 'il_ocean_export', reducerName: 'setOexDelete' },
    2: { tableName: 'il_air_import', reducerName: 'setAimDelete' },
    3: { tableName: 'il_air_export', reducerName: 'setAexDelete' },
    4: { tableName: 'il_ftl_ltl', reducerName: 'setTruckingDelete' },
};

/** Shipment Field Mappings for Copy. */
export const shipmentFieldMappings = {
    0: [
        'id',
        'il_trade_partner_id_client',
        'il_team_id',
        'il_trade_partner_id_forwarder',
        'incoterm',
        'il_location_id_pol',
        'il_location_id_pod',
        'il_location_id_fpod',
    ],
    1: [
        'id',
        'il_trade_partner_id_client',
        'il_team_id',
        'il_trade_partner_id_forwarder',
        'incoterm',
        'il_location_id_pol',
        'il_location_id_pod',
        'il_location_id_fpod',
    ],
    2: [
        'id',
        'il_trade_partner_id_client',
        'il_team_id',
        'il_trade_partner_id_forwarder',
        'incoterm',
        'il_location_id_aol',
        'il_location_id_aod',
        'il_location_id_faod',
    ],
    3: [
        'id',
        'il_trade_partner_id_client',
        'il_team_id',
        'il_trade_partner_id_forwarder',
        'incoterm',
        'il_location_id_aol',
        'il_location_id_aod',
        'il_location_id_faod',
    ],
    4: [
        'id',
        'il_trade_partner_id_client',
        'il_team_id',
        'il_trade_partner_id_shipper',
        'il_trade_partner_id_consignee',
        'shipment_type',
    ],
};

/** Set a redux state for each shipment main. */
export const formSetters = {
    0: setOimFormData,
    1: setOexFormData,
    2: setAimFormData,
    3: setAexFormData,
    4: setTruckingFormData,
};
